import React from 'react';
import classNames from 'classnames';
import { ATMLabel } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { DispatchStatuses } from 'src/constants';
import styles from './fire-dispatch-status.module.scss';

type IProps = {
  dispatchStatus?: string;
  className?: string;
};

const DispatchStatus: React.FC<IProps> = ({
  dispatchStatus = null,
  className,
}) => {
  if (!dispatchStatus) {
    return null;
  }

  let color = '#D3D3D3';
  let status = Lang.LBL_CANCELLED;

  switch (dispatchStatus) {
    case DispatchStatuses.Cancelled: {
      color = '#D3D3D3';
      status = Lang.LBL_CANCELLED;
      break;
    }

    case DispatchStatuses.Dispatched: {
      color = '#fed8b1';
      status = Lang.LBL_DISPATCHED;
      break;
    }

    case DispatchStatuses.InFlight: {
      color = '#E3FICC';
      status = Lang.LBL_IN_FLIGHT;
      break;
    }

    case DispatchStatuses.Landed: {
      color = '#D3D8EE';
      status = Lang.LBL_LANDED;
      break;
    }

    case DispatchStatuses.Completed: {
      color = '#D2F0F9';
      status = Lang.LBL_COMPLETED;
      break;
    }
  }

  return (
    <ATMLabel
      className={classNames(styles.container, className)}
      horizontal
      style={{ backgroundColor: color, lineHeight: '20px' }}
    >
      {status}
    </ATMLabel>
  );
};

export default DispatchStatus;
